import { useEffect } from "react";
import { useState } from "react";
import { Modal, Col, Row, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { getAllBanks } from "../../Helpers/apiCalls/banksAPi";
import {
    payMultipleSalesInvoice,
    getSingleSalesInvoice,
    recordStatusInvoice,
} from "../../Helpers/apiCalls/franchiseeApi";
import {
    getTodayDateISO,
    refreshPage,
    toastStyle,
    numberFormatInt,
    numberFormat
} from "../../Helpers/Utils/Common";
import { validateFranchise } from "../../Helpers/Validation/Franchise/FranchiseModalValidation";
import InputError from "../../Components/InputError/InputError";
import ReactLoading from "react-loading";

export default function MultiplePaymentModal({
    show,
    onHide,
    balance,
    invoices,
}) {
    let navigate = useNavigate();
    const [banks, setBanks] = useState([]);
    const [bankTo, setBankTo] = useState([]);
    const [bankValue, setBankValue] = useState({
        name: "from_bank_id",
        label: "",
        value: "",
    });
    const [depositValue, setDepositValue] = useState({
        name: "to_bank_id",
        label: "",
        value: "",
    });

    const [isErrorPayment, setIsErrorPayment] = useState({
        invoice_no: false,
        payment_type: false,
        payment_date: false,
        to_bank_id: false,
        bank_name: false,
        cheque_number: false,
        cheque_date: false,
        reference_number: false,
    });
    const [isClicked, setIsClicked] = useState(false);

    const [selectedInvoices, setSelectedInvoices] = useState();
    const [addDetails, setAddDetails] = useState(
        {
            to_bank_id: "",
            bank_name: "",
            cheque_number: "",
            cheque_date: "",
            reference_number: "",
        }
    );
    function handleAmountChange(e,index) {
        var newList = invoices
        newList[index][e.target.name] = e.target.value;

        setSelectedInvoices(newList);

        
        var _grandTotal = selectedInvoices
            .map((invoice) => parseFloat(invoice.amount))
            .reduce((a, b) => a + b, 0);
        setAddDetails((prev) => {
                return {
                    ...prev,
                    ["amount"]: _grandTotal,
                };
            });
    }
    
    
    function handleAddChange(e) {
        var newList = invoices
        setSelectedInvoices(newList);

        const { name, value } = e.target;
        if (name === "from_bank_id") {
            setBankValue(() => {
                return { name: name, value: value, label: e.label };
            });
        } else if (name === "to_bank_id") {
            setDepositValue(() => {
                return { name: name, value: value, label: e.label };
            });
        }
        setAddDetails((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
    }

    async function fetchBanks() {
        const response = await getAllBanks();
        var banks = response.data.data.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        );

        var cleanedArray = banks.map((bank) => {
            var info = {};

            info.name = "from_bank_id";
            info.label = bank.bank_name;
            info.value = bank.id;

            return info;
        });
        setBanks(cleanedArray);

        var cleanedArray2 = banks.map((bank) => {
            var info = {};

            info.name = "to_bank_id";
            info.label = bank.bank_name;
            info.value = bank.id;

            return info;
        });
        setBankTo(cleanedArray2);
    }
    async function pay() {
        
        
        if (
            validateFranchise(
                addDetails,
                setIsErrorPayment
            )
        ) {
            setIsClicked(true);
            const response = await payMultipleSalesInvoice(addDetails, selectedInvoices);
            if (response.data) {
                if (response.data.status === "success") {
                    toast.success("Payment saved!", {
                        style: toastStyle(),
                    });
                    setTimeout(() => {
                        refreshPage()
                    }, 1000);
                    // setTimeout(() => navigate("/salesinvoice/print/" + id), 1000);
                }
            } else if (response.error) {
                toast.error("Something went wrong", { style: toastStyle() });
                setIsClicked(false);
            }
        } else {
            toast.error("Please fill in all fields", { style: toastStyle() });
        }
    }

    useEffect(() => {
        fetchBanks();
        setAddDetails({
            payment_date: getTodayDateISO(),
            deposit_date: getTodayDateISO(),
            payment_type: "cash", 
            amount: balance,

            check_date: "",
            check_number: "",
            bank_name: "",

            payment_description: "",
        });
        var newList = invoices
        setSelectedInvoices(newList);
    }, []);

    return (
        <div>
            <Modal show={show} onHide={onHide} size="lg" centered>
                <Modal.Header closeButton>
                    <span className="page-title"> Add Payment</span>
                </Modal.Header>
                <Modal.Body className="return-body">
                    <div>
                        <Row className="mt-4 mb-2">
                            <Col>
                                <span className="edit-label">
                                    Payment Date
                                    <span className="color-red"> *</span>
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Control
                                    type="date"
                                    name="payment_date"
                                    className="nc-modal-custom-text"
                                    defaultValue={
                                        addDetails.payment_date
                                    }
                                    onChange={(e) => handleAddChange(e)}
                                />
                            </Col>
                            <InputError
                                    isValid={isErrorPayment.payment_date}
                                    message={"Payment date is required"}
                                />
                        </Row>
                        <Row className="mt-4 mb-2">
                            <Col>
                                <span className="edit-label">
                                    Invoice Number
                                    <label className="badge-required">{` *`}</label>
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Control
                                    type="text"
                                    name="invoice_no"
                                    className="nc-modal-custom-text"
                                    value={addDetails.invoice_no}
                                    onChange={(e) => handleAddChange(e)}
                                />
                                <InputError isValid={isErrorPayment.invoice_no} message={"Invoice number is required"}/>
                            </Col>
                        </Row>
                        <Row className="mt-4 mb-2">
                            <Col>
                                <span className="edit-label">
                                    Payment Method
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Check
                                    inline
                                    label="Cash"
                                    name="payment_type"
                                    value="cash"
                                    type="radio"
                                    defaultChecked
                                    onClick={(e) => {
                                        handleAddChange(e);
                                    }}
                                />
                                <Form.Check
                                    inline
                                    label="Check"
                                    name="payment_type"
                                    type="radio"
                                    value="check"
                                    onClick={(e) => {
                                        handleAddChange(e);
                                    }}
                                />
                                <Form.Check
                                    inline
                                    label="Online"
                                    name="payment_type"
                                    value="online"
                                    type="radio"
                                    onClick={(e) => {
                                        handleAddChange(e);
                                    }}
                                />
                                <Form.Check
                                    inline
                                    label="Package Inclusion"
                                    name="payment_type"
                                    value="package_inclusion"
                                    type="radio"
                                    onClick={(e) => {
                                        handleAddChange(e);
                                    }}
                                />
                                <Form.Check
                                    inline
                                    label="Others"
                                    name="payment_type"
                                    value="others"
                                    type="radio"
                                    onClick={(e) => {
                                        handleAddChange(e);
                                    }}
                                />
                            </Col>
                            <InputError
                                isValid={isErrorPayment.payment_type}
                                message={"Payment type is required"}
                            />
                            <Col>
                                <span className="">Total:</span>
                                <span className="edit-label"> </span>
                                <span className="green">{numberFormat(balance)}</span>
                            </Col>
                        </Row>
                    </div>

                    {/* CASH PAYMENT DETAILS */}
                    {addDetails.payment_type === "cash" && (
                        <>
                        {
                            invoices?.map((data, index) => {
                                // 
                                return(
                                    <>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Invoice No.
                                                <span className="color-red"> *</span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Branch
                                                <span className="color-red"> *</span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Balance
                                                <span className="color-red"> *</span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Amount
                                                <span className="color-red"> *</span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <span className="edit-label black">
                                                {data?.id ? data.id : ""}
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label black">
                                                {data?.buyer_branch_name ? data.buyer_branch_name : ""}
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label black">
                                                {data?.balance ? data.balance : "0"}
                                            </span>
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="amount"
                                                className="nc-modal-custom-text"
                                                defaultValue={data?.balance ? numberFormatInt(data?.balance) : "0"}
                                                onChange={(e) => handleAmountChange(e, index)}
                                            />
                                        </Col>
                                    </Row>
                                    </>
                                )
                            })
                        }
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposit Date
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        name="deposit_date"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            addDetails.deposit_date
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposited to
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select bank..."
                                        defaultValue={depositValue}
                                        options={bankTo}
                                        onChange={(e) =>
                                            handleAddChange({
                                                target: {
                                                    name: e.name,
                                                    value: e.value,
                                                    label: e.label,
                                                },
                                            })
                                        }
                                    />
                                    <InputError
                                        isValid={isErrorPayment.to_bank_id}
                                        message={"Deposited to is required is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Term (days)
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="term_days"
                                        className="nc-modal-custom-text"
                                        value={
                                            addDetails.term_days
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Remarks
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        as="textarea"
                                        name="remarks"
                                        value={
                                            setAddDetails.remarks
                                        }
                                        className="nc-modal-custom-text"
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}

                    {/* CHECK PAYMENT DETAILS */}
                    {addDetails.payment_type === "check" && (
                        <>
                            {
                                invoices?.map((data, index) => {
                                    return(
                                        <>
                                        <Row className="mt-4 mb-2">
                                            <Col>
                                                <span className="edit-label">
                                                    Invoice No.
                                                    <span className="color-red"> *</span>
                                                </span>
                                            </Col>
                                            <Col>
                                                <span className="edit-label">
                                                    Branch
                                                    <span className="color-red"> *</span>
                                                </span>
                                            </Col>
                                            <Col>
                                                <span className="edit-label">
                                                    Balance
                                                    <span className="color-red"> *</span>
                                                </span>
                                            </Col>
                                            <Col>
                                                <span className="edit-label">
                                                    Amount
                                                    <span className="color-red"> *</span>
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <span className="edit-label black">
                                                    {data?.id ? data.id : ""}
                                                </span>
                                            </Col>
                                            <Col>
                                                <span className="edit-label black">
                                                    {data?.buyer_branch_name ? data.buyer_branch_name : ""}
                                                </span>
                                            </Col>
                                            <Col>
                                                <span className="edit-label black">
                                                    {data?.balance ? data.balance : "0"}
                                                </span>
                                            </Col>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    name="amount"
                                                    className="nc-modal-custom-text"
                                                    defaultValue={data?.balance ? numberFormatInt(data?.balance) : "0"}
                                                    onChange={(e) => handleAmountChange(e, index)}
                                                />
                                            </Col>
                                        </Row>
                                        </>
                                    )
                                })
                            }
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Bank Name
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="bank_name"
                                        className="nc-modal-custom-text"
                                        value={
                                            addDetails.bank_name
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.bank_name}
                                        message={"Bank name is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Check Date
                                    </span>
                                </Col>
                                <Col>
                                    <span className="edit-label">
                                        Check Number
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        name="cheque_date"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            addDetails.cheque_date
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.cheque_date}
                                        message={"Check date is required"}
                                    />
                                </Col>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="cheque_number"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            addDetails.cheque_number
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.cheque_number}
                                        message={"Cheque number is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposit Date
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        name="deposit_date"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            addDetails.deposit_date
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposited to
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select bank..."
                                        defaultValue={depositValue}
                                        options={bankTo}
                                        onChange={(e) =>
                                            handleAddChange({
                                                target: {
                                                    name: e.name,
                                                    value: e.value,
                                                    label: e.label,
                                                },
                                            })
                                        }
                                    />
                                    <InputError
                                        isValid={isErrorPayment.to_bank_id}
                                        message={"Deposited to is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Term (days)
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="term_days"
                                        className="nc-modal-custom-text"
                                        value={
                                            addDetails.term_days
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Remarks
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        as="textarea"
                                        name="remarks"
                                        value={addDetails.remarks}
                                        className="nc-modal-custom-text"
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}

                    {/* OTHERS PAYMENT DETAILS */}
                    {(addDetails.payment_type === "online" || addDetails.payment_type === "package_inclusion" || addDetails.payment_type === "others") && (
                        <>
                            {
                                invoices?.map((data, index) => {
                                    return(
                                        <>
                                        <Row className="mt-4 mb-2">
                                            <Col>
                                                <span className="edit-label">
                                                    Invoice No.
                                                    <span className="color-red"> *</span>
                                                </span>
                                            </Col>
                                            <Col>
                                                <span className="edit-label">
                                                    Branch
                                                    <span className="color-red"> *</span>
                                                </span>
                                            </Col>
                                            <Col>
                                                <span className="edit-label">
                                                    Balance
                                                    <span className="color-red"> *</span>
                                                </span>
                                            </Col>
                                            <Col>
                                                <span className="edit-label">
                                                    Amount
                                                    <span className="color-red"> *</span>
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <span className="edit-label black">
                                                    {data?.id ? data.id : ""}
                                                </span>
                                            </Col>
                                            <Col>
                                                <span className="edit-label black">
                                                    {data?.buyer_branch_name ? data.buyer_branch_name : ""}
                                                </span>
                                            </Col>
                                            <Col>
                                                <span className="edit-label black">
                                                    {data?.balance ? data.balance : "0"}
                                                </span>
                                            </Col>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    name="amount"
                                                    className="nc-modal-custom-text"
                                                    defaultValue={data?.balance ? numberFormatInt(data?.balance) : "0"}
                                                    onChange={(e) => handleAmountChange(e, index)}
                                                />
                                            </Col>
                                        </Row>
                                        </>
                                    )
                                })
                            }
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposit Date
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        name="deposit_date"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            addDetails.deposit_date
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposited to
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select bank..."
                                        defaultValue={depositValue}
                                        options={bankTo}
                                        onChange={(e) =>
                                            handleAddChange({
                                                target: {
                                                    name: e.name,
                                                    value: e.value,
                                                    label: e.label,
                                                },
                                            })
                                        }
                                    />
                                    <InputError
                                        isValid={isErrorPayment.to_bank_id}
                                        message={"Deposited to is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Payment Description
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="payment_description"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            addDetails.payment_description
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Reference Number
                                        <label className="badge-required">{` *`}</label>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="reference_number"
                                        className="nc-modal-custom-text"
                                        value={
                                            addDetails.reference_number
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.reference_number}
                                        message={"Reference number to is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Term (days)
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="term_days"
                                        className="nc-modal-custom-text"
                                        value={
                                            addDetails.term_days
                                        }
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Remarks
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        as="textarea"
                                        name="remarks"
                                        value={addDetails.remarks}
                                        className="nc-modal-custom-text"
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="return-footer">
                    <button
                        type="button"
                        className="button-secondary"
                        onClick={onHide}
                    >
                        Cancel
                    </button>
                    {isClicked ? (
                        <div className="button-primary d-flex justify-content-center">
                            <ReactLoading
                                type="bubbles"
                                color="#FFFFFF"
                                height={50}
                                width={50}
                            />
                        </div>
                    ) : (
                        <button
                            type="button"
                            className="button-primary"
                            onClick={() => pay()}
                        >
                            Pay
                        </button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
}
